import { useSyncExternalStore } from "react";

/** Tailwind's `md` breakpoint: below it we're on a phone layout. */
const DESKTOP = "(min-width: 768px)";

function subscribe(onChange: () => void): () => void {
  const mq = window.matchMedia(DESKTOP);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

const isDesktop = () => window.matchMedia(DESKTOP).matches;

/** True at tablet/desktop widths; false on phones. Updates live on resize/rotate. */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, isDesktop, () => true);
}
